module.exports = __webpack_public_path__ + "static/media/stop.1baa8b88.mp3";